<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add">新增</el-button>
        </template>
      </dynamic-search>
      <drag-dialog
        append-to-body
        :show.sync="dialogVisible"
        title="岗位"
        :enableDrag="true"
        width="500px"
        @close="cancel"
      >
        <dynamic-form
          :formConfig="formConfig"
           labelWidth="80px"
          v-model="form"
          @submit="submit"
          @cancelForm="cancel"
          ref="pageForm"
        ></dynamic-form>
      </drag-dialog>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
        :showNumber="false"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
  import "@/components/EditDataTable";
  import DragDialog from "@/components/DragDialog";
  import DynamicSearch from "@/components/DynamicSearch";
  import DataTableMixin from "@/mixins/DataTableMixin";
  import "@/components/dynamic-form";
  import { addPosition, deletePosition, editPosition } from "@/api/basic/position";
  import {getDeptTree} from '@/api/dept'

export default {
  name: "PartnerBudgetTask",
  components: { DynamicSearch, DragDialog },
  mixins: [DataTableMixin],
  data() {
    return {
      form: {},
      dialogVisible: false,
      delLoading: false,
      // 表单配置
      formConfig: {
        formItemList: [
          {
            type: "text",
            maxlength: "50",
            showWordLimit: true,
            key: "code",
            label: "岗位代码",
            value: "",
            rules: [
              { required: true, message: "岗位代码生成失败", trigger: "blur" },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "岗位代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "text",
            maxlength: "100",
            showWordLimit: true,
            key: "name",
            label: "岗位名称",
            value: "",
            placeholder: "请输入职级名称",
            rules: [
              { required: true, message: "岗位名称不能为空", trigger: "blur" }
            ]
          },
          {
            label: '所属组织',
            key: 'deptId',
            type: 'treeSelect',
            multiple: false,
            value: '',
            clearable: true,
            filterable: false,
            props: {
              children: 'children',
              label: 'name',
              value: 'id'
            },
            options: this.treeData,
            rules: {
              required: true, message: '不能为空', trigger: 'change'
            }
          },
          {
            type: "textarea",
            maxlength: "200",
            showWordLimit: true,
            validateEvent: true,
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      },
      treeData: [],
      // 表格设置
      tableHead: [
          {
            label: "岗位代码",
            prop: "code"
          },
          {
            label: "岗位名称",
            prop: "name",
            query: {
              type: "input"
            },
            align: "left"
          },
          {
            label: "备注",
            prop: "remark"
          }
        ]
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit()
    });
    const idx = this.formConfig.formItemList.findIndex(i => i.key === 'deptId')
    if (idx !== -1) {
      getDeptTree().then(res => {
        this.treeData = res.data
        this.$set(this.formConfig.formItemList[idx], 'options', this.treeData)
      })
    }
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/post/findList";
      const params = { page: this.page, size: this.offset };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 新增
    add() {
      this.form = {};
      this.dialogVisible = true;
    },
     // 删除
    del(row) {
      this.delLoading = true;
      deletePosition(row.id)
        .then(() => {
           this.$notify({ title: "删除成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.delLoading = false;
        })
        .catch(() => {
          this.delLoading = false;
        });
    },
    // 修改
    edit(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    submit() {
      if (this.form.id) {
        editPosition(this.form).then(res => {
           this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      } else {
        addPosition(this.form).then(res => {
           this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      }
    },
    cancel() {
      this.dialogVisible = false;
    },
  }
};
</script>

<style scoped lang="scss">

</style>
